var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { raFormRowSectionCls } from "./Row.less";
function FormRowSection(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */ React.createElement("div", {
    className: raFormRowSectionCls
  }, children);
}
__name(FormRowSection, "FormRowSection");
export {
  FormRowSection
};
